import React, { Component } from 'react';
import { connect } from 'react-redux';

import DooAwbList from './DooAwbList';
import AttachmentsContainer from '../../../../attachments/AttachmentsContainer';
import ReadyForCarriageCheckContainer from '../../../../readyForCarriageCheck/ReadyForCarriageCheckContainer';

import { History } from 'history';
import { baseUrl } from '../../../../../api/baseUrl';
import PickupOrderAwb from '../../../../../models/PickupOrderAwb';
import dooAwbListStyles from './dooAwbList.module.css';
import commonStyles from '../../../../common/common.module.css';

import { receiveError } from '../../../../../store/actions/notificationAction';
import ResponseError from '../../../../../models/ResponseError';
import PickupOrderGha from '../../../../../models/PickupOrderGha';
import ManualEntryModalContainer from '../../manualEntry/ManualEntryModalContainer';
import DriverTruckEdit from '../../../../../models/DriverTruckEdit';
import ManualEntryEdit from '../../../../../models/ManualEntryEdit';
import { entryAddClearData, entryAddData, entryEditAddData, entryEditClearData } from '../../../../../store/actions/manualEntryEditAction';
import ManualEntryAdd from '../../../../../models/ManualEntryAdd';
import { setAwbAction } from '../../../../../store/actions/selectAwbAction';

interface DooAwbListContainerProps {
  awbs: Array<PickupOrderAwb>;
  selectedDooNumber: string;
  loadListAwbs: (doNumber: string) => void;
  entryAddData: (manualEntryData: ManualEntryAdd) => void;
  entryEditAddData: (manualEntryData: ManualEntryEdit) => void;
  receiveError: (error: ResponseError) => void;
  doo: PickupOrderGha;
  openModalManualEntry: () => void;
  history: History;
  manualEntryEditClearData: () => void;
  manualEntryAddClearData: () => void;
  selectedAwbNumber: string;
  selectedAwbCode: string;
  setAwbAction: (number: string, changed: boolean) => void;
  changed: boolean;

};

interface DooAwbListContainerState {
  awbs: Array<PickupOrderAwb>;
  awbCode: string;
  awbNumber: string;
  awbVer: number;
  isAttachmentsDialogOpen: boolean;
  isRForCheckDialogOpen: boolean;
  doNumber: string;
  openModalManualEntry: boolean;
  selectedDrvTrkData: DriverTruckEdit;
};

class DooAwbListContainer extends Component<DooAwbListContainerProps, DooAwbListContainerState> {

  state: DooAwbListContainerState = {
    awbs: [],
    awbCode: '',
    awbNumber: '',
    awbVer: 0,
    isAttachmentsDialogOpen: false,
    isRForCheckDialogOpen: false,
    doNumber: '',
    openModalManualEntry: false,
    selectedDrvTrkData: {
      orderNumber: '',
      delivery_company_name: '',
      delivery_company_name_new: '',
      driver_id: '',
      driver_id_type: '',
      driver_name: '',
      driver_vehichle_registration: '',
      rfs_number: ''
    },
  }

  componentDidMount() {
      
    this.setState({
      awbs: this.props.awbs,
      doNumber: this.props.selectedDooNumber
    });
  }

  componentDidUpdate(prevProps: DooAwbListContainerProps) {

    if (prevProps.awbs !== this.props.awbs) {

      this.setState({
        awbs: this.props.awbs,
        awbCode: this.props.awbs[0].code,
        awbNumber: this.props.awbs[0].number,
        awbVer: this.props.awbs[0].version,
        doNumber: this.props.selectedDooNumber,
      });
    }
    if (this.props.changed !== prevProps.changed && this.props.changed) {
      setTimeout(() => {
        const elementIndex = this.state.awbs.findIndex((awb) => awb.number == this.props.selectedAwbNumber);
        this.scrollRow(elementIndex);
      }, 500);
    }
  }

  scrollRow = (rowIndex: number = 11) => {
    const table = document.getElementById('myTable');
    if (table) {
      const rows = table.getElementsByTagName('tr');
      if (rowIndex >= 0 && rowIndex < rows.length) {
        rows[rowIndex].scrollIntoView({ behavior: 'smooth' });
      }
      const table2 = document.getElementsByClassName('MuiTableBody-root');
    }

  }

  handleCloseModalManualEntry = (isUpdated?: boolean): void => {
    this.props.manualEntryAddClearData();
    this.props.manualEntryEditClearData();
    this.setState({ openModalManualEntry: false });
  }

  openDialog = (type: string, awbCode: string, awbNumber: string, awbVer: number): void => {

    switch (type) {
      case 'attachments' : this.setState({ isAttachmentsDialogOpen: true });
        break;
      case 'rForCheck' : this.setState({ isRForCheckDialogOpen: true });
        break;
      default: break;
    }
    this.setState({ awbCode, awbNumber, awbVer });
  }

  printAwbInfoClicked = (awbCode: string, awbNumber: string, version: number) => {

    let url: string = `${baseUrl}pickup_order/${this.state.doNumber}/awb/${awbCode}/${awbNumber}/${version}/file`;

    window.open(url);
  }

  addAwbToOrder = () => {
    this.setState({ openModalManualEntry: true });
  }

  handleOpenManualEntryEdit = (): void => {
    this.props.manualEntryEditClearData();
    const data = this.props.doo;
    const manualEntryEditData: ManualEntryAdd = {
      isAddMode: true,
      driverData: {
        driverId: data.driver_id || '',
        driverIdType: data.driver_id_type || '',
        name: data.driver_name || '',
        company: data.delivery_company_name || '',
        truckPlateNumber: data.driver_vehichle_registration || '',
        driverTime: data.driver_checkin_time,
        rfsNumber: data.rfs_number || ''
      },
      forwarderId: data.id_forwarder,
      dockId: data.id_dock || -1,
      orderNumber: data.number,
      isInterline: data.forwarder_company_info.type === "interline" ? true : false,
      isRfs: data.rfs_number ? true : false,
      orderId: data.id
    };

    this.setState({ openModalManualEntry: true });
    this.props.entryAddData(manualEntryEditData);
  }

  closeDialog = (type: string): void => {

    switch (type) {
      case 'attachments':
        this.props.loadListAwbs( this.state.doNumber );
        this.setState({ isAttachmentsDialogOpen: false });
        break;
      case 'rForCheck':
        this.props.loadListAwbs( this.state.doNumber );
        this.setState({ isRForCheckDialogOpen: false });
        break;
      default: break;
    }
    this.setState({ awbCode: '', awbNumber: '' });
  }

  render () {

    return (

      <div className={ `${ commonStyles.wrapper } ${ dooAwbListStyles.wrapper }` }>
         <h3 className={commonStyles.header}> List of Airwaybills</h3>
          <DooAwbList
            awbs={ this.state.awbs }
            openDialog={ this.openDialog }
            printAwbInfoClicked={ this.printAwbInfoClicked }
            addAwb={ this.handleOpenManualEntryEdit }
            doo={ this.props.doo }
            changed={ this.props.changed }
            selectedAwbNumber={ this.props.selectedAwbNumber }
          />
          { this.state.isAttachmentsDialogOpen &&
            <AttachmentsContainer
              code={ this.state.awbCode }
              number={ this.state.awbNumber }
              version={ this.state.awbVer }
              process = {'export'}
              closeAttachments={()=> this.closeDialog('attachments') }
              refreshAwbs={false}
              orderNumber={this.state.doNumber}
            />
          }
          { this.state.isRForCheckDialogOpen &&
            <ReadyForCarriageCheckContainer
              doNumber={ this.state.doNumber }
              code={ this.state.awbCode }
              number={ this.state.awbNumber }
              handleClose={ this.closeDialog }
              version={ this.state.awbVer }
            />
          }
          { this.state.openModalManualEntry &&
            <ManualEntryModalContainer
              type={'do'}
              history={this.props.history }
              modalOpen={this.state.openModalManualEntry}
              handleCloseModal={this.handleCloseModalManualEntry}
              driverData={{
                name: this.state.selectedDrvTrkData.driver_name,
                company: this.state.selectedDrvTrkData.delivery_company_name,
                check_in: null
              }}
            />
          }
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    selectedAwbCode: state.selectAwb.selectedAwbCode,
    selectedAwbNumber: state.selectAwb.selectedAwbNumber,
    changed: state.selectAwb.changed
  };
};


const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    manualEntryEditClearData: () => dispatch(entryEditClearData()),
    manualEntryAddClearData: () => dispatch(entryAddClearData()),
    entryAddData: (manualEntryData: ManualEntryAdd) => dispatch(entryAddData(manualEntryData)),
    entryEditAddData: (manualEntryData: ManualEntryEdit) => dispatch(entryEditAddData(manualEntryData)),
    setAwbAction: (awbNumber: string, changed: boolean) => dispatch(setAwbAction(awbNumber, changed))


  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DooAwbListContainer);